module.exports = __webpack_public_path__ + "static/theChain-e99563558787f5d338faee8eaa89e45a.jpg";